export function getCookie(name) {
  if (process.env.REACT_APP_ENVIRONMENT === "development") {
    return "Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwczovL2FwaS11YXQubWF3YWxvZy5jb20vYWRtaW4vdjIvYXBpL2xvZ2luIiwiaWF0IjoxNzY1ODAzNzI5LCJleHAiOjE3NjU4OTAxMjksIm5iZiI6MTc2NTgwMzcyOSwianRpIjoiYkl3N0NxdG5na3MxcjJMSiIsInN1YiI6IjEyMzIiLCJwcnYiOiI5YWQ1ODU3N2ZhYjZmYmMxNTU0MzRkMzU5MWVkZjE2NGExNzc2NWFhIiwiYXV0aGlkIjoxMjMyLCJvcmdpZCI6MTA1LCJ1c2VyaWQiOjEyMzIsImRhdGFiYXNlbmFtZSI6InJhZ3VyciIsIm9yZ19jb2RlIjoicmFndXJyIiwidGltZXpvbmUiOiIgKyBpbnRlcnZhbCAnMDUgaG91cnMgMzAgbWludXRlcyciLCJyb2xlaWQiOjQ5NywicGF5bWVudF9zdGF0dXMiOnRydWUsImF1dGhvcml0aWVzIjpbIlJPTEVfVVNFUiJdfQ.akQYpBUOjwwgKJQuSBqIVoF0oZtTWozSOLBFVf3YbWk";
  }
  const accountsUrl = process.env.REACT_APP_ACCOUNTS_URL;
  const cookieString = document.cookie; // Get all cookies as a string
  console.log(cookieString);
  const cookies = cookieString.split(";"); // Split into individual cookies

  for (let i = 0; i < cookies.length; i++) {
    const cookie = cookies[i].trim(); // Remove leading spaces
    if (cookie.startsWith(name + "=")) {
      if (cookie.substring(name.length + 1) === "") {
        const currentURL = window.location.href;

        const redirectData = {
          redirectPath: currentURL,
          app: "transport",
          ts: Date.now(),
        };

        console.warn("🔐 Saving redirect in window.name:", redirectData);

        // ✅ TAB-SPECIFIC, CROSS-DOMAIN SAFE
        window.name = JSON.stringify(redirectData);
        window.location.href = `${accountsUrl}/login`;
      }
      return cookie.substring(name.length + 1); // Return the value of the cookie
    }
  }
  // window.location.href = `${accountsUrl}/login`;
  return null; // Return null if the cookie is not found
}
